var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import styled, { css, } from 'styled-components';
import { propsToForward, useMediaSize } from '../tools/utils';
import { FormFieldHelper } from '../FormFieldHelper';
var initialState = {
    align: 'stacked',
    variant: 'single-select',
    selectedKeys: [],
    showError: false,
    customErrorId: '',
    childIndex: function (key) { return 0; },
    onSelected: function (key) {
        /* noop */
    },
    onKeyDown: function (e, key) {
        /* noop */
    },
    /**
     * Initial guess at child count is 3.
     * Will be updated in component below on mount.
     */
    hideIconSmDown: false,
    inlineCardWidth: undefined,
    inlineCardHeight: undefined,
};
var stackedStyles = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var align = _a.align, space = _a.theme.space;
    if (align === 'stacked') {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        flex-direction: column;\n        justify-content: stretch;\n      "], ["\n        flex-direction: column;\n        justify-content: stretch;\n      "])));
    }
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
});
var inlineStyles = css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var align = _a.align, space = _a.theme.space;
    if (align === 'inline') {
        return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        flex-direction: row;\n        justify-content: flex-start;\n      "], ["\n        flex-direction: row;\n        justify-content: flex-start;\n      "])));
    }
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
});
var StyledContainer = styled.div.withConfig({
    shouldForwardProp: propsToForward,
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var align = _a.align, space = _a.theme.space;
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    gap: ", ";\n    align-items: stretch;\n    box-sizing: border-box;\n    width: ", ";\n    ", "\n    ", "\n  "], ["\n    display: flex;\n    gap: ", ";\n    align-items: stretch;\n    box-sizing: border-box;\n    width: ", ";\n    ", "\n    ", "\n  "])), space.xs, align === 'inline' ? 'fit-content' : '100%', inlineStyles, stackedStyles);
});
export var GroupContext = React.createContext(initialState);
export var GroupConsumer = GroupContext.Consumer;
var CardSelectionGroup = React.forwardRef(function (_a, ref) {
    var variant = _a.variant, align = _a.align, inlineCardWidth = _a.inlineCardWidth, inlineCardHeight = _a.inlineCardHeight, onSelection = _a.onSelection, defaultSelection = _a.defaultSelection, _b = _a.allowDeselection, allowDeselection = _b === void 0 ? false : _b, _c = _a.hideIconSmDown, hideIconSmDown = _c === void 0 ? false : _c, errorNotification = _a.errorNotification, children = _a.children, ariaLabelledby = _a.ariaLabelledby, ariaRequired = _a.ariaRequired, others = __rest(_a, ["variant", "align", "inlineCardWidth", "inlineCardHeight", "onSelection", "defaultSelection", "allowDeselection", "hideIconSmDown", "errorNotification", "children", "ariaLabelledby", "ariaRequired"]);
    var isSmDown = useMediaSize('SmDown');
    var prevDefaultSelection = React.useRef(defaultSelection);
    var _d = __read(React.useState(false), 2), isIntersecting = _d[0], setIsIntersecting = _d[1];
    var outerRef = React.useRef(null);
    var _e = __read(React.useState(isSmDown || isIntersecting ? 'stacked' : align), 2), safeAlign = _e[0], setSafeAlign = _e[1];
    var _f = __read(useState([]), 2), selectedKeys = _f[0], setSelectedKeys = _f[1];
    var childCount = useMemo(function () { return children.length; }, [children]);
    var childIndex = useCallback(function (childKey) {
        return children.findIndex(function (item) { return item.props.cardId === childKey; });
    }, [children]);
    var onSelectionCallback = useCallback(function (newKeys) {
        if (variant === 'single-select') {
            ;
            onSelection(newKeys.length ? newKeys[0] : undefined);
        }
        else if (variant === 'multi-select') {
            ;
            onSelection(newKeys);
        }
    }, [variant, onSelection]);
    var removeKey = useCallback(function (key) {
        setSelectedKeys(function (keys) {
            var newKeys = keys.reduce(function (acc, k) {
                if (k === key)
                    return acc;
                return __spreadArray(__spreadArray([], __read(acc), false), [k], false);
            }, []);
            onSelectionCallback(newKeys);
            return newKeys;
        });
    }, [setSelectedKeys, onSelectionCallback]);
    var handleSelection = useCallback(function (key, handleDuplicates) {
        if (handleDuplicates === void 0) { handleDuplicates = 'remove_duplicate'; }
        var includesKey = selectedKeys.includes(key);
        if (includesKey && (allowDeselection || variant === 'multi-select')) {
            if (handleDuplicates === 'ignore_duplicate')
                return undefined;
            if (handleDuplicates === 'remove_duplicate') {
                return removeKey(key);
            }
        }
        return setSelectedKeys(function (keys) {
            var newKeys = variant === 'single-select' ? [key] : __spreadArray(__spreadArray([], __read(keys), false), [key], false);
            onSelectionCallback(newKeys);
            return newKeys;
        });
    }, [
        removeKey,
        allowDeselection,
        variant,
        selectedKeys,
        setSelectedKeys,
        onSelectionCallback,
    ]);
    var onSelectPrev = useCallback(function (fromIndex) {
        var LAST_INDEX = childCount - 1;
        if (fromIndex > 0) {
            handleSelection(children[fromIndex - 1].props.cardId);
        }
        else {
            handleSelection(children[LAST_INDEX].props.cardId);
        }
    }, [children, childCount, handleSelection]);
    var onSelectNext = useCallback(function (fromIndex) {
        var LAST_INDEX = childCount - 1;
        if (fromIndex < LAST_INDEX) {
            handleSelection(children[fromIndex + 1].props.cardId);
        }
        else {
            handleSelection(children[0].props.cardId);
        }
    }, [children, childCount, handleSelection]);
    var hasDefaultSelectionChanged = React.useMemo(function () {
        var _a;
        if (!defaultSelection)
            return false;
        if (typeof defaultSelection === 'string') {
            var hasChanged = defaultSelection !== prevDefaultSelection.current;
            if (hasChanged)
                prevDefaultSelection.current = defaultSelection;
            return hasChanged;
        }
        if (Array.isArray(defaultSelection)) {
            if (defaultSelection.length !== ((_a = prevDefaultSelection.current) === null || _a === void 0 ? void 0 : _a.length)) {
                return true;
            }
        }
        return false;
    }, [defaultSelection, prevDefaultSelection]);
    useEffect(function () {
        if (!defaultSelection)
            return;
        if (typeof defaultSelection === 'string') {
            handleSelection(defaultSelection, 'ignore_duplicate');
        }
        else if (Array.isArray(defaultSelection)) {
            defaultSelection.forEach(function (selection) {
                handleSelection(selection, 'ignore_duplicate');
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasDefaultSelectionChanged]);
    var onKeyDownSingleSelect = function (e, cardId) {
        var fromIndex = childIndex(cardId);
        if (fromIndex >= 0) {
            var key = e.key;
            // left or up arrow keys
            if (['ArrowLeft', 'ArrowUp'].includes(key)) {
                onSelectPrev(fromIndex);
                e.preventDefault();
            }
            // right or down arrow keys
            if (['ArrowRight', 'ArrowDown'].includes(key)) {
                onSelectNext(fromIndex);
                e.preventDefault();
            }
        }
    };
    /**
     * With the `multi-select` variant, we don't want arrow navigation with the keyboard. Instead, we want the native
     * tab navigation, which is why this function is a no-op for `multi-select`.
     */
    var onKeyDownMultiSelect = function () {
        /* noop */
    };
    var onKeyDown = variant === 'single-select' ? onKeyDownSingleSelect : onKeyDownMultiSelect;
    var role = variant === 'single-select' ? 'radiogroup' : 'group';
    var defaultInnerRef = React.useRef();
    var combinedInnerRef = function (el) {
        if (typeof ref === 'function') {
            ref(el);
        }
        else if (ref) {
            ref.current = el;
        }
        defaultInnerRef.current = el;
    };
    var cb = function (entries) {
        if (entries[0].intersectionRatio !== 1 && safeAlign === 'inline') {
            return setIsIntersecting(true);
        }
        if (safeAlign === 'stacked') {
            return setIsIntersecting(false);
        }
        return undefined;
    };
    React.useEffect(function () {
        var opts = {
            root: outerRef.current,
            rootMargin: '0px',
            threshold: 1,
        };
        /**
         * This IntersectionObserver is responsible monitoring the overall width of an `inline` card group.
         * If the card group extends past its container, then the alignment will change to `stacked`.
         */
        var observer = new IntersectionObserver(cb, opts);
        if (defaultInnerRef.current)
            observer.observe(defaultInnerRef.current);
        return function () { return observer.disconnect(); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var isAriaRequired = ariaRequired && variant !== 'multi-select'
        ? { 'aria-required': 'true' }
        : {};
    var _g = __read(React.useState(), 2), inlineInnerWidth = _g[0], setInlineInnerWidth = _g[1];
    var _h = __read(React.useState(false), 2), isResizing = _h[0], setIsResizing = _h[1];
    React.useEffect(function () {
        var _a;
        if (safeAlign === 'inline') {
            setInlineInnerWidth((_a = defaultInnerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width);
        }
    }, [safeAlign, isResizing]);
    var resizeTimeout;
    var handleSetIsResizing = function handleSetIsResizing() {
        setIsResizing(true);
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () { return setIsResizing(false); }, 200);
    };
    React.useEffect(function () {
        window.addEventListener('resize', handleSetIsResizing);
        return function () {
            return window.removeEventListener('resize', handleSetIsResizing);
        };
    }, []);
    React.useEffect(function () {
        var _a;
        var isLessThanOuterContainer = (inlineInnerWidth || 0) <
            (((_a = outerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) || 0);
        setSafeAlign(isSmDown || (isIntersecting && !isLessThanOuterContainer)
            ? 'stacked'
            : align);
    }, [inlineInnerWidth, isSmDown, isIntersecting, align, isResizing]);
    return (React.createElement(GroupContext.Provider, { value: __assign(__assign({}, initialState), { align: safeAlign, variant: variant, selectedKeys: selectedKeys, showError: !!(errorNotification === null || errorNotification === void 0 ? void 0 : errorNotification.message), customErrorId: errorNotification === null || errorNotification === void 0 ? void 0 : errorNotification.customId, childIndex: childIndex, onSelected: function (key) { return handleSelection(key); }, onKeyDown: onKeyDown, hideIconSmDown: !!hideIconSmDown, defaultSelection: defaultSelection, inlineCardWidth: inlineCardWidth, inlineCardHeight: inlineCardHeight }) },
        React.createElement("div", { ref: outerRef },
            React.createElement(StyledContainer, __assign({ ref: combinedInnerRef, role: role, align: safeAlign, "aria-labelledby": ariaLabelledby }, isAriaRequired, others), children)),
        React.createElement(FormFieldHelper, { errorNotification: __assign(__assign({}, (errorNotification || {})), { show: !!(errorNotification === null || errorNotification === void 0 ? void 0 : errorNotification.message) }) })));
});
var GroupForProps = function () { return React.createElement(React.Fragment, null); };
export { CardSelectionGroup, GroupForProps };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=CardSelectionGroup.js.map